export const KeyDownEvent = 'keydown';
export const KeyPressEvent = 'keypress';
export const KeyUpEvent = 'keyup';
export const DragEnterEvent = 'dragenter';
export const DragLeaveEvent = 'dragleave';
export const DragOverEvent = 'dragover';
export const PointerDownEvent = 'pointerdown';
export const PointerUpEvent = 'pointerup';
export const PointerMoveEvent = 'pointermove';
export const PointerOutEvent = 'pointerout';
export const PointerOverEvent = 'pointerover';
export const MouseDownEvent = 'mousedown';
export const MouseUpEvent = 'mouseup';
export const MouseMoveEvent = 'mousemove';
export const MouseOutEvent = 'mouseout';
export const MouseOverEvent = 'mouseover';
export const ClickEvent = 'click';
export const DoubleClickEvent = 'dblclick';
export const WheelEvent = 'wheel';
export const MouseWheelEvent = 'mousewheel';
export const TouchStartEvent = 'touchstart';
export const TouchMoveEvent = 'touchmove';
export const TouchEndEvent = 'touchend';

export const Events = [
  KeyDownEvent,
  KeyPressEvent,
  KeyUpEvent,
  DragEnterEvent,
  DragLeaveEvent,
  DragOverEvent,
  PointerDownEvent,
  PointerUpEvent,
  PointerMoveEvent,
  PointerOutEvent,
  PointerOverEvent,
  MouseDownEvent,
  MouseUpEvent,
  MouseMoveEvent,
  MouseOutEvent,
  MouseOverEvent,
  ClickEvent,
  DoubleClickEvent,
  WheelEvent,
  MouseWheelEvent,
  TouchStartEvent,
  TouchMoveEvent,
  TouchEndEvent
];

export const TooltipShowEvent = PointerMoveEvent;

export const TooltipHideEvent = MouseOutEvent;

export const HrefEvent = ClickEvent;
